import { clientAxios, commonAxios } from '@/plugins/axios'

export const lineLink = async ({ email, lineId }) =>
  commonAxios.post('/v1/common/mail/check', {
    email,
    line_id: lineId,
  })

export const confirmEmail = async (token) =>
  commonAxios.post('/v1/common/line-link/confirm', {
    token,
  })

export const checkFriendLine = (line_user_id) =>
  clientAxios.post('/v1/setting/line/check-friend-line', {
    line_user_id,
  })

export const linkAccount = (body) => clientAxios.post('/v1/setting/line/social-save-account', body)

export const linkAccountBusiness = async ({ customerId, accessToken }) =>
  clientAxios.post(
    '/v1/setting/line/link-line/business-account',
    {
      customer_id: customerId,
      line_access_token: accessToken,
    },
    {
      headers: {
        'x-provider': 'line',
      },
    }
  )
